<div class="snack-container" [attr.role]="messageRole" [attr.aria-live]="ariaLive" aria-atomic="true">
    <div class="icon-div">
        <span class="material-icons-outlined" aria-hidden="true">
            {{getIcon}}
        </span>
    </div>
    <div class="message-div">

        <ng-container *ngIf="data.snackType === 'error' || data.snackType === 'warn'; else noError">
            <mat-accordion>
                <mat-expansion-panel [expanded]="panelOpenState" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                    <mat-expansion-panel-header>
                        <mat-panel-description>
                            {{ 'ErrorAlertMessage' | translate: {Default: "Oops! Something went wrong"} }}
                        </mat-panel-description>
                    </mat-expansion-panel-header>
    
                    <div class="error-div">
                        <div class="header" *ngIf="data.snackType === 'error'">
                            {{ 'ErrorAlertErrorDetails' | translate: {Default: "Error Details"} }}
                        </div>
                        {{data.message}}
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </ng-container>

        <ng-template #noError>
            {{data.message}}
        </ng-template>

    </div>
    <div class="clear-div">
        <button type="button" appPreventDoubleClick (throttledClick)="dismiss()" class="dismiss" [attr.aria-label]="'Dismiss notification'">
            <span class="material-icons-outlined" aria-hidden="true">clear</span>
            <span class="sr-only">Dismiss notification</span>
        </button>
    </div>
</div>